import { gql } from "@apollo/client";

export const GET_ALL_DOCUMENTOS_LEGALES = gql`
query GetDocumentoLegalByIdTipoModulo($idTipoModulo: Int!) {
    documentoLegalByIdTipoModulo(idTipoModulo: $idTipoModulo){
        idDocumentoLegal,
        idTipoModulo,
        descripcion,
        nombre
    }
}`;